import { render, staticRenderFns } from "./rewardContainerTab.vue?vue&type=template&id=0817e42a&lang=pug"
import script from "./rewardContainerTab.vue?vue&type=script&lang=js"
export * from "./rewardContainerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports